import { SmartLink, useWarrantyClaimContext } from '@components';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import DownloadForOfflineOutlined from '@mui/icons-material/DownloadForOfflineOutlined';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Box } from '@mui/material';

import { styled } from '@mui/material';
import { colors } from '@themes/colors';
import { breakpoints } from '@themes/theme.helpers';
import { formatBytes } from '@utils/formatBytes.utils';

const DocumentCardBox = styled(Box)`
  background: #fff;
  border-radius: 4px;
  display: flex;
  width: 100%;
  flex-direction: row;
  gap: 8px;
  padding: 16px;
  ${breakpoints.up('md')} {
    gap: 16px;
    align-items: center;
    justify-content: flex-start;
    flex-direction: row;
  }
`;

const IconBox = styled(Box)`
  display: none;
  ${breakpoints.up('sm')} {
    display: inline-block;
    width: 36px;
    height: 36px;
  }
`;

const DocumentIcon = styled(DescriptionOutlinedIcon)`
  color: ${colors.text.tertiary};
  font-size: 36px;
`;

const DownloadIcon = styled(DownloadForOfflineOutlined)`
  font-size: 36px;
`;

const RemoveIcon = styled(HighlightOffIcon)`
  font-size: 36px;
  :hover {
    cursor: pointer;
    color: ${colors.error.main};
  }
`;

const DataBox = styled(Box)`
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  gap: 4px;
  ${breakpoints.up('md')} {
    flex-direction: column;
    gap: 4px;
  }
`;

const Size = styled(Box)`
  color: ${colors.text.tertiary};
`;
const TitleBox = styled(Box)`
  color: ${colors.text.primary};
  font-weight: 700;
`;

export const WarrantyFileCard = () => {
  const { form, currentFileId, isReadOnly } = useWarrantyClaimContext();
  const currentFile = form.getValues('recipeFile');
  const claimId = form.getValues('id');

  const onRemove = () => {
    form.setValue('recipeFile', null);
  };

  return (
    <DocumentCardBox className='hover-shadow' sx={{ position: 'relative' }}>
      <IconBox>
        <DocumentIcon />
      </IconBox>
      <DataBox>
        <TitleBox>{currentFile[0]?.fileName || currentFile[0]?.name}</TitleBox>
        <Size>
          {currentFile[0]?.length
            ? formatBytes(currentFile[0].length)
            : formatBytes(currentFile[0].size)}
        </Size>
      </DataBox>
      <Box>
        {!isReadOnly && (
          <IconBox onClick={onRemove}>
            <RemoveIcon sx={{ fontSize: '36px' }} />
          </IconBox>
        )}
        {currentFileId ? (
          <IconBox>
            <SmartLink
              href={`/api/warranty-claims/${claimId}/attachment/${currentFileId}/download`}
              className='link'
              target='_blank'
              download
            >
              <DownloadIcon />
            </SmartLink>
          </IconBox>
        ) : null}
      </Box>
    </DocumentCardBox>
  );
};
